import { render, staticRenderFns } from "./WritingPhonics1Form.vue?vue&type=template&id=626de3a1&"
import script from "./WritingPhonics1Form.vue?vue&type=script&lang=js&"
export * from "./WritingPhonics1Form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports